module.exports = __webpack_public_path__ + "img/macatuba.11e7848a.png";